import { render, staticRenderFns } from "./CreateDateNotificationDialog.vue?vue&type=template&id=5ee0b0c2&scoped=true"
import script from "./CreateDateNotificationDialog.vue?vue&type=script&lang=js"
export * from "./CreateDateNotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateDateNotificationDialog.vue?vue&type=style&index=0&id=5ee0b0c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee0b0c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee0b0c2')) {
      api.createRecord('5ee0b0c2', component.options)
    } else {
      api.reload('5ee0b0c2', component.options)
    }
    module.hot.accept("./CreateDateNotificationDialog.vue?vue&type=template&id=5ee0b0c2&scoped=true", function () {
      api.rerender('5ee0b0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/notification/CreateDateNotificationDialog.vue"
export default component.exports